import camelCase from 'lodash/camelCase';

export default (obj) => {
  const keys = Object.keys(obj);
  const camelCasedObj = {};

  keys.forEach((key) => {
    camelCasedObj[camelCase(key)] = obj[key];
  });

  return camelCasedObj;
};
